import { CapacitorHttp } from "@capacitor/core";

const isError = (resp) => {
    if(resp.isError) return true;

    const status = resp.status;
    return status > 399;
}

const formatError = (err) => {
    const message = err?.data?.detail;
    console.log("error msg: ", message);
    console.log("error:", err);
    return {
        message,
        ...err
    }
}

const NativeFetchClient = {

    async delete(url, config={}) {

        const options = {
            url,
            ...config,
        }

        const resp = await CapacitorHttp.delete(options);
        if(isError(resp)) {
            console.log("error for", "delete", "url")
            throw formatError(resp);
        }
        return resp
    },

    async get(url, config = {}) {

        const options = {
            url,
            ...config,
        }

        const resp = await CapacitorHttp.get(options);
        if(isError(resp)) {
            console.log("error for", "get", "url")
            throw formatError(resp);
        }
        return resp;
    },

    async post(url, data, config = {}) {

        const headers = {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            ...config.headers,
        };

        const options = {
            url,
            data,
            ...config,
            headers: headers,
        }

        const resp = await CapacitorHttp.post(options);
        if(isError(resp)) {
            console.log("error for", "post", "url")
            throw formatError(resp);
        }
        return resp;
    },

    async put(url, data, config = {}) {

        const headers = {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            ...config.headers,
        }

        const options = {
            url,
            data,
            ...config,
            headers: headers,
        }

        const resp = await CapacitorHttp.put(options);
        if(isError(resp)) {
            console.log("error for", "put", "url")
            throw formatError(resp);
        }
        return resp;
    },
};

export default NativeFetchClient;
